import { create } from 'zustand';
import useSWR from 'swr';
import apiClient from '../services/apiClient';
import { AdminStat, Brand, Ingredient, Problem, SkinType } from '../types';


// Fetcher для SWR
const fetcher = (url: string) => apiClient.get(url).then((res) => res.data);

// Zustand Stores
export const useBrandsStore = create<{ 
  brands: Brand[]; 
  fetchBrands: () => void;
  createBrand: (names: string) => Promise<void>;
  updateBrand: (id: number, name: string) => Promise<void>;
  deleteBrand: (id: number) => Promise<void>;
}>((set, get) => ({
  brands: [],
  fetchBrands: async () => {
    const data = await fetcher('/api/brands');
    set({ brands: data });
  },
  createBrand: async (names: string) => {
    await apiClient.post('/api/brands', { names });
    // Обновляем список брендов после создания
    const data = await fetcher('/api/brands');
    set({ brands: data });
  },
  updateBrand: async (id: number, name: string) => {
    await apiClient.put(`/api/brands/${id}`, { name });
    // Обновляем список брендов после обновления
    const data = await fetcher('/api/brands');
    set({ brands: data });
  },
  deleteBrand: async (id: number) => {
    await apiClient.delete(`/api/brands/${id}`);
    // Обновляем список брендов после удаления
    const data = await fetcher('/api/brands');
    set({ brands: data });
  },
}));

export const useIngredientsStore = create<{ ingredients: Ingredient[]; fetchIngredients: () => void }>((set) => ({
  ingredients: [],
  fetchIngredients: async () => {
    const data = await fetcher('/api/ingredients');
    set({ ingredients: data });
  },
}));

export const useProblemsStore = create<{ problems: Problem[]; fetchProblems: () => void }>((set) => ({
  problems: [],
  fetchProblems: async () => {
    const data = await fetcher('/api/problems');
    set({ problems: data.problems });
  },
}));

export const useSkinTypesStore = create<{ skinTypes: SkinType[]; fetchSkinTypes: () => void }>((set) => ({
  skinTypes: [],
  fetchSkinTypes: async () => {
    const data = await fetcher('/api/skin-types');
    set({ skinTypes: data.skin_types });
  },
}));

export const useAdminStatStore = create<{ adminStat: AdminStat; fetchStats: () => void }>((set) => ({
  adminStat: {} as AdminStat,
  fetchStats: async () => {
    const data = await fetcher('/api/admin/stats');
    // Предполагается, что API возвращает объект статистики напрямую
    set({ adminStat: data });
  },
}));
